// SentimentTopicSection.js
import React from 'react';
import SmallSelect from '../../../Common/Select/SmallSelect';
import styled from 'styled-components';


const SelectWrapper = styled.div`
  width: 100px;
  padding: 20px 0 10px 35px;
`;
const TopPostTopicHeading = styled.div`
  font-weight: 400;

  display: flex;
  align-items: center;
  gap: 20px;

  font-family: 'Inter';
  &:before {
    display: inline-block;
    content: '';
    width: 17px;
    height: 17px;
  }
`;


const TopPostTopicWrapper = styled.div`
  margin-left: 40px;

  .topicList {
    padding-left: 35px;
    padding-bottom: 10px;
    font-family: 'Inter';
    color: #2a2929;
  }

  .positiveTopic {
    color: rgba(3, 198, 82, 1);

    &:before {
      background: linear-gradient(180deg, #a1fcc6 0%, rgba(3, 198, 82, 1) 100%);
    }
  }
  .neutralTopic {
    color: rgba(239, 205, 29, 1);
    &:before {
      background: linear-gradient(
        180deg,
        #ffe092 0%,
        rgba(239, 205, 29, 1) 100%
      );
    }
  }
  .negativeTopic {
    color: rgba(238, 19, 7, 1);
    &:before {
      background: linear-gradient(180deg, #ff8c86 0%, rgba(238, 19, 7, 1) 100%);
    }
  }
`;


const SentimentTopicSection = ({
  label,
  className,
  dropdownId,
  topicData,
  sentimentKey,
  handleChange,
  renderTopics,
  openDropdown,
  setOpenDropdown,
  
  totalTopicsColumn
}) => {
  return (
    <TopPostTopicWrapper>
      <div>
        <TopPostTopicHeading className={className}>
          {label}
        </TopPostTopicHeading>
        <SelectWrapper>
          <SmallSelect
            aria-label={`${sentimentKey} Topic Select`}
            onChange={(topic) => handleChange(topic, sentimentKey)}
            dropdownId={dropdownId}
            options={totalTopicsColumn(topicData)}
            openDropdown={openDropdown}
            setOpenDropdown={setOpenDropdown}
            sentimentDrillDown={true}
          />
        </SelectWrapper>
        <div className='topicList'>
          {renderTopics(topicData, sentimentKey) || `Insufficient Data`}
        </div>
      </div>
    </TopPostTopicWrapper>
  );
};

export default SentimentTopicSection;
